import { render, staticRenderFns } from "./RawMaterials.vue?vue&type=template&id=cb470cb2"
import script from "./RawMaterials.vue?vue&type=script&lang=js"
export * from "./RawMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports